import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';
import {i18nReducer} from 'react-redux-i18n';
import configuration from '@peoplenet/vi-components-ui/src/app/configuration/configurationReducer';
import switchCustomer from '../switchCustomer/SwitchCustomerReducer';
import library from '../library/LibraryReducer';
import dashboard from '../dashboard/DashboardReducer';
import libraryFilters from '@peoplenet/vi-components-ui/src/LibraryFilter/libraryFilterReducer';
import filterReducer from '../components/DesktopFilter/filterReducer';
import player from './player';
import videoTagging from './videoTagging';
import system from '../system/SystemReducer';
import customer from './customer';
import linkAccount from '../linkAccount/LinkAccountReducer';
import user from '@peoplenet/vi-components-ui/src/app/user/UserReducer';
import onDemand from '../onDemand/OnDemandReducer';
import report from '@peoplenet/vi-components-ui/src/report/ReportReducer';
import reportFilter from '@peoplenet/vi-components-ui/src/report/filters/ReportFiltersReducer';
import downloadVideo from '../downloadVideo/DownloadVideoReducer';
import dvr from '@peoplenet/vi-components-ui/src/DVRhealth/DVRhealthReducer';
import dvrFilter from '@peoplenet/vi-components-ui/src/DVRhealth/filters/HealthFiltersReducer';
import dvrSnapshots from '@peoplenet/vi-components-ui/src/DVRSnapshots/DVRSnapshotsReducer';
import userSettings from '@peoplenet/vi-components-ui/src/UserSettings/UserSettingsReducer';
import notification from '../notification/NotificationReducer';

export default history => combineReducers({
  router: connectRouter(history),
  configuration,
  filterReducer,
  library,
  libraryFilters,
  linkAccount,
  player,
  i18n: i18nReducer,
  system,
  customer,
  switchCustomer,
  videoTagging,
  user,
  onDemand,
  report,
  reportFilter,
  downloadVideo,
  dvr,
  dvrFilter,
  dvrSnapshots,
  dashboard,
  userSettings,
  notification
});
